var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"calculator"}},[_c('el-row',[(_vm.isMobile)?_c('calcMobile'):_c('calcDesktop'),_c('historicalDataDialog')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }